import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text, Flex } from "sprout-ui-primitives";
import { Link } from "react-router-dom";
import { LandingImage as BaseLandingImage } from "sprout-ui-dom/dist/Landing";
import imageCache from "sprout-lib/dist/image-cache";
import styled from "styled-components";
import { media, themeGet } from "sprout-ui-theme";
const LandingImage = styled(BaseLandingImage)`
  border-radius: 30px;
  box-shadow: 0 0 0 2px #fce3d2;

  transition: box-shadow 0.15s linear;
`;
const FeaturesPageFeatureWrapper = styled(Flex)`
  ${media.up("medium", "pointer")} {
    will-change: transform;
    transition: transform 0.15s linear;

    :hover {
      transform: translateY(-2px);

      ${LandingImage} {
        box-shadow: 0 0 0 2px ${themeGet("colors.blue.500")};
      }
    }
  }
`;
const FeaturesPageFeature = (props)=>{
    const { title , description , fragment , thumbnail  } = props;
    return /*#__PURE__*/ _jsxs(FeaturesPageFeatureWrapper, {
        flexDirection: "column",
        as: Link,
        to: `/features/${fragment}`,
        children: [
            /*#__PURE__*/ _jsx(LandingImage, {
                pb: "75%",
                src: process.env.NODE_ENV === "development" ? thumbnail : imageCache(`${process.env.ROOT_URL}/${thumbnail}`)
            }),
            /*#__PURE__*/ _jsx(Text, {
                as: "h2",
                fontSize: 3,
                fontWeight: "bold",
                textDecoration: "underline",
                color: "blue.500",
                textAlign: "center",
                my: 3,
                children: title
            }),
            /*#__PURE__*/ _jsx(Text, {
                as: "p",
                fontSize: 2,
                textAlign: "center",
                lineHeight: 1.25,
                children: description
            })
        ]
    });
};
export default FeaturesPageFeature;
